// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_action_box {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.main_action_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.main_action_header h3 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    letter-spacing: -0.01em;
}

.home_action_main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    width: 100%;
}

.home_action_first_box {
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 18px 20px;
    gap: 16px;
    border-radius: var(--radius-md);
    transition: all var(--transition-normal);
    box-shadow: var(--shadow-sm);
    text-decoration: none;
    position: relative;
    overflow: hidden;
}

.home_action_first_box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: var(--primary);
    opacity: 0;
    transition: opacity var(--transition-fast);
}

.home_action_first_box:hover {
    box-shadow: var(--shadow-md);
    border-color: var(--primary-50);
    transform: translateY(-1px);
}

.home_action_first_box:hover::before {
    opacity: 1;
}

.home_action_icon {
    width: 44px;
    height: 44px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
}

.home_action_icon_payouts {
    background-color: #FEF3C7;
    color: #D97706;
}

.home_action_icon_deposits {
    background-color: #DBEAFE;
    color: #2563EB;
}

.home_action_icon_ibans {
    background-color: #E0E7FF;
    color: #4F46E5;
}

.home_action_icon_utility {
    background-color: #FCE7F3;
    color: #DB2777;
}

.home_action_icon_ago_deposits {
    background-color: #D1FAE5;
    color: #059669;
}

.home_action_icon_ago_payouts {
    background-color: #FEE2E2;
    color: #DC2626;
}

.home_action_info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1 1;
}

.home_action_first_box p {
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    color: var(--text-primary);
    line-height: 1.1;
    letter-spacing: -0.02em;
}

.home_action_first_box_text {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 500;
}

.home_action_first_box_text img {
    width: 14px;
    height: 14px;
    opacity: 0.4;
    transition: all var(--transition-fast);
}

.home_action_first_box:hover .home_action_first_box_text img {
    opacity: 0.7;
    transform: translateX(2px);
}

.home_action_first_box:hover .home_action_first_box_text {
    color: var(--primary);
}

.reset_clock_button {
    padding: 8px 18px;
    border-radius: var(--radius-sm);
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    color: var(--text-secondary);
    font-weight: 500;
    font-size: 13px;
    transition: all var(--transition-fast);
    display: flex;
    align-items: center;
    gap: 6px;
}

.reset_clock_button:hover {
    background-color: var(--danger-light);
    border-color: var(--danger);
    color: var(--danger);
}

@media (max-width: 1200px) {
    .home_action_main {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .home_action_main {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/MainActions/mainActions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,+BAA+B;IAC/B,wCAAwC;IACxC,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".main_action_box {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.main_action_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.main_action_header h3 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n    letter-spacing: -0.01em;\n}\n\n.home_action_main {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n    width: 100%;\n}\n\n.home_action_first_box {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 18px 20px;\n    gap: 16px;\n    border-radius: var(--radius-md);\n    transition: all var(--transition-normal);\n    box-shadow: var(--shadow-sm);\n    text-decoration: none;\n    position: relative;\n    overflow: hidden;\n}\n\n.home_action_first_box::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 3px;\n    height: 100%;\n    background: var(--primary);\n    opacity: 0;\n    transition: opacity var(--transition-fast);\n}\n\n.home_action_first_box:hover {\n    box-shadow: var(--shadow-md);\n    border-color: var(--primary-50);\n    transform: translateY(-1px);\n}\n\n.home_action_first_box:hover::before {\n    opacity: 1;\n}\n\n.home_action_icon {\n    width: 44px;\n    height: 44px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    font-size: 20px;\n}\n\n.home_action_icon_payouts {\n    background-color: #FEF3C7;\n    color: #D97706;\n}\n\n.home_action_icon_deposits {\n    background-color: #DBEAFE;\n    color: #2563EB;\n}\n\n.home_action_icon_ibans {\n    background-color: #E0E7FF;\n    color: #4F46E5;\n}\n\n.home_action_icon_utility {\n    background-color: #FCE7F3;\n    color: #DB2777;\n}\n\n.home_action_icon_ago_deposits {\n    background-color: #D1FAE5;\n    color: #059669;\n}\n\n.home_action_icon_ago_payouts {\n    background-color: #FEE2E2;\n    color: #DC2626;\n}\n\n.home_action_info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n    flex: 1;\n}\n\n.home_action_first_box p {\n    margin: 0;\n    font-size: 28px;\n    font-weight: 700;\n    color: var(--text-primary);\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n}\n\n.home_action_first_box_text {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n.home_action_first_box_text img {\n    width: 14px;\n    height: 14px;\n    opacity: 0.4;\n    transition: all var(--transition-fast);\n}\n\n.home_action_first_box:hover .home_action_first_box_text img {\n    opacity: 0.7;\n    transform: translateX(2px);\n}\n\n.home_action_first_box:hover .home_action_first_box_text {\n    color: var(--primary);\n}\n\n.reset_clock_button {\n    padding: 8px 18px;\n    border-radius: var(--radius-sm);\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    color: var(--text-secondary);\n    font-weight: 500;\n    font-size: 13px;\n    transition: all var(--transition-fast);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.reset_clock_button:hover {\n    background-color: var(--danger-light);\n    border-color: var(--danger);\n    color: var(--danger);\n}\n\n@media (max-width: 1200px) {\n    .home_action_main {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .home_action_main {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
